import { CaseTagType } from "@/core/app/slices/user/user.type"

export interface DropdownOption {
  value: number
  label: string
}

// Sample data object based on labelComposerOptions
export const SAMPLE_DATA = {
  "Stage Number": "01",
  "First Name Initial": "J",
  "First Name": "James",
  "Last Name Initial": "A",
  "Last Name": "Anderson",
  "Last Name up to 7 char": "Anderso",
}

export const STATIC_SAMPLE_DATA = {
  "First Name": "James",
  "Last Name": "Anderson",
  "Stage Number": "01"
}

// Label composer dropdown options
export const LABEL_COMPOSER_OPTIONS: DropdownOption[] = [
  { value: CaseTagType.FirstNameInitial, label: "First Name Initial" },
  { value: CaseTagType.FirstName, label: "First Name" },
  { value: CaseTagType.LastNameInitial, label: "Last Name Initial" },
  { value: CaseTagType.LastNameShort, label: "Last Name up to 7 char" },
  { value: CaseTagType.LastName, label: "Last Name" },
  { value: CaseTagType.StageNumber, label: "Stage Number" },
  { value: CaseTagType.Empty, label: "Empty" },
]
